const initialState = () => ({
  // logs: [],
  visitorsDomains: [],
  visitors: [],
})

const state = initialState

const getters = {
  // hostingErrorLogs: state => state.logs,
  hostingVisitorsDomains: state => state.visitorsDomains,
  hostingVisitors: state => state.visitors,
}

const mutations = {
  // SET_LOGS: (state, logs) => { state.logs = logs },
  CLEAR_HOSTING_SSH_STORE (state) {
    const s = initialState()

    Object.keys(s).forEach(key => {
      state[key] = s[key]
    })
  },
  SET_VISITORS_DOMAINS: (state, visitorsDomains) => { state.visitorsDomains = visitorsDomains },
  SET_VISITORS: (state, visitors) => { state.visitors = visitors },
}

const actions = {
  // get list of public ssh keys
  async loadLogs ({ commit, dispatch }, payload) {
    try {
      const data = {
        uapi_module: 'Stats',
        uapi_function: 'get_site_errors',
        ...payload
      }
      const response = await dispatch('cpanel_uapi', { ...data }, { root: true })

      return response.payload.data
      // commit('SET_LOGS', response.payload.data)
    } catch (e) {
      throw e
    }
  },
  async loadVisitorsDomains ({ commit, dispatch }) {
    const data = {
      api2_module: 'Stats',
      api2_method: 'listlastvisitors'
    }
    try {
      const response = await dispatch('cpanel_api2', data, { root: true })
      commit('SET_VISITORS_DOMAINS', response.payload.data)
    } catch (e) {
      commit('SET_VISITORS_DOMAINS', [])
      throw e
    }
  },
  // http://documentation.cpanel.net:8090/display/DD/cPanel+API+2+Functions+-+Stats%3A%3Alastvisitors
  // NEW https://api.docs.cpanel.net/openapi/cpanel/operation/list_stats_by_domain/
  async loadVisitors ({ commit, dispatch }, { domain, ssl }) {
    // const data = {
    //   api2_module: 'Stats',
    //   api2_method: 'lastvisitors',
    //   domain,
    // }
    const data = {
      uapi_module: 'Stats',
      uapi_function: 'list_stats_by_domain',
      engine: 'analog',
      domain,
      ssl
    }
    try {
      const response = await dispatch('cpanel_uapi', data, { root: true })
      commit('SET_VISITORS', response.payload.data)
    } catch (e) {
      commit('SET_VISITORS', [])
      throw e
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
